<template>
    <div class="invention-history page">
        <Search
            :show-invention-type="true"
            :show-invention-session="true"
            :text="'名稱/主題/內容'"
            @search="search"
        />
        <Add
            @editData="editData"
        />
        <div class="table-block">
            <div class="total">
                總共: {{ total }} 筆資料
            </div>
            <v-data-table
                :headers="ApplyHeader"
                :items="list"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :loading="loading"
                class="data-table"
                :footer-props="footerProps"
            >
                <template v-slot:item.type="{ item }">
                    {{ DataType(item.type) }}
                </template>
                <template v-slot:item.image.zhTw="{ item }">
                    <v-img
                        :src="image(item.image.zhTw)"
                        class="data-img"
                    />
                </template>
                <template v-slot:item.image.en="{ item }">
                    <v-img
                        :src="image(item.image.en)"
                        class="data-img"
                    />
                </template>
                <template v-slot:item.operate="{ item }">
                    <v-btn
                        class="mx-1"
                        dark
                        small
                        depressed
                        :disabled="isOperate"
                        color="green"
                        @click="editData(item)"
                    >
                        <v-icon dark>
                            mdi-pencil
                        </v-icon>
                    </v-btn>
                    <v-btn
                        class="mx-1 delete-btn"
                        dark
                        small
                        depressed
                        :disabled="isOperate"
                        color="red"
                        @click="deleteData(item)"
                    >
                        <v-icon dark>
                            mdi-trash-can
                        </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
        <HistoryTeamDialog
            ref="child"
            :show-type="true"
            :edit-dialog="editDialog"
            @close="closeEdit"
            @saveEdit="saveEdit"
            @saveData="saveData"
            @search="search"
        />
    </div>
</template>

<script>
import API from '@/api';
import Mixin from '@/mixins/Mixin.vue';
import APIFormData from '@/api/libs/form-data';
import _ from 'lodash';
import HistoryTeamDialog from '@/components/Dialog/HistoryTeamDialog.vue';
import ApplyHeader from '@/static-data/invention-manage-history-team-header.json';

export default {
    components: { HistoryTeamDialog },
    mixins: [Mixin],
    data() {
        return {
            ApplyHeader,
            typeOptions: [
                { label: '大專組', value: 'college' },
                { label: '高中職組', value: 'senior' },
                { label: '全部', value: null },
            ],
        };
    },
    watch: {
        options: {
            handler() {
                this.search();
            },
            deep: true,
        },
    },
    created() {
        this.search();
    },
    mounted() {
    },
    methods: {
        DataType(type) {
            const number = _.findIndex(this.typeOptions, { value: type });
            return this.typeOptions[number].label;
        },
        async deleteData(item) {
            this.isOperate = true;
            try {
                // 刪除
                await API.InventionTeam.PrivateDeleteResource(item.id);
            } catch (e) {
                this.handleError({
                    message: e || '刪除異常',
                    color: 'error',
                });
            }
            this.search();
        },
        async search(filterItem) {
            // 搜尋
            const { page, itemsPerPage } = this.options;
            const { inventionSession, inventionType, text } = filterItem ?? {};
            this.loading = true;
            const filter = [];
            if (inventionSession) {
                filter.push(`session.zhTw:${inventionSession}`);
            }
            if (inventionType) {
                filter.push(`type:${inventionType}`);
            }
            try {
                const res = await API.InventionTeam.PrivateList({
                    params: {
                        offset: (page - 1) * itemsPerPage,
                        limit: itemsPerPage,
                        filter: filter.join(';'),
                        search: text || undefined,
                    },
                });
                this.list = res.data.raw;
                this.total = res.data.total;
                this.loading = false;
            } catch (e) {
                this.loading = false;
                this.handleError({
                    message: e || '搜尋異常',
                    color: 'error',
                });
            }
            this.isOperate = false;
        },
        async saveData(item) {
            const data = {
                type: item.type,
                fb: item.fb,
                youtube: item.youtube,
                ig: item.ig,
                mail: item.mail,
                session: {
                    zhTw: item.session.zhTw,
                    en: item.session.zhTw,
                },
                rank: {
                    zhTw: item.rank.zhTw,
                    en: item.rank.en,
                },
                image: {
                    zhTw: item.image.zhTw,
                    en: item.image.en,
                },
                title: {
                    zhTw: item.title.zhTw,
                    en: item.title.en,
                },
                name: {
                    zhTw: item.name.zhTw,
                    en: item.name.en,
                },
                selfTheme: {
                    zhTw: item.selfTheme.zhTw,
                    en: item.selfTheme.en,
                },
                shareTheme: {
                    zhTw: item.shareTheme.zhTw,
                    en: item.shareTheme.en,
                },
                content: {
                    zhTw: item.content.zhTw,
                    en: item.content.en,
                },
            };
            const form = new APIFormData(data, [{
                urls: [
                    item.image.zhTw,
                    item.image.en,
                    ...item.images,
                ],
            }]);
            try {
                if (item.id) {
                // 修改
                    await API.InventionTeam.PrivateUpdateResource(item.id, form);
                    this.setAlert({
                        message: '更新成功',
                        color: 'success',
                    });
                } else {
                // 新增
                    await API.InventionTeam.PrivateCreateResource(form);
                    this.setAlert({
                        message: '新增成功',
                        color: 'success',
                    });
                }
            } catch (e) {
                this.handleError({
                    message: e || '新增修改異常',
                    color: 'error',
                });
            }
            this.search();
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
